import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const TransfoHubPage = lazy(() =>
  import('../pages/transformation-pro/HubPage').then((m) => ({ default: m.HubPage }))
)
const TransfoProgramsPage = lazy(() =>
  import('../pages/transformation-pro/ProgramsPage').then((m) => ({ default: m.ProgramsPage }))
)
const TransfoTechDebtPage = lazy(() =>
  import('../pages/transformation-pro/TechDebtPage').then((m) => ({ default: m.TechDebtPage }))
)
const TransfoAdoptionPage = lazy(() =>
  import('../pages/transformation-pro/AdoptionPage').then((m) => ({ default: m.AdoptionPage }))
)
const TransfoRoadmapPage = lazy(() =>
  import('../pages/transformation-pro/RoadmapPage').then((m) => ({ default: m.RoadmapPage }))
)
const TransfoStepsPage = lazy(() =>
  import('../pages/transformation-pro/StepsPage').then((m) => ({ default: m.StepsPage }))
)

export const transformationProRoutes: RouteObject[] = [
  {
    path: 'transformation-pro',
    children: [
      { index: true, element: <TransfoHubPage /> },
      { path: 'hub', element: <TransfoHubPage /> },
      { path: 'programs', element: <TransfoProgramsPage /> },
      { path: 'tech-debt', element: <TransfoTechDebtPage /> },
      { path: 'adoption', element: <TransfoAdoptionPage /> },
      { path: 'roadmap', element: <TransfoRoadmapPage /> },
      { path: 'steps', element: <TransfoStepsPage /> },
    ],
  },
]
